import { Table, TableBody } from 'primeng/table';
import { CategoryService } from 'src/app/_services/category.service';
import {
    Component,
    OnInit,
    ViewChild,
    AfterViewInit,
    Output,
    EventEmitter,
} from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { Paginator } from 'primeng/paginator';
import { GlobalService } from 'src/app/_services/global.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { DepartmentService } from 'src/app/_services/department.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs';
import { FilterServiceService } from 'src/app/_services/filter-service.service';
import { BaseService } from 'src/app/_services/base.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-inventory-departments',
    templateUrl: './inventory-departments.component.html',
    styleUrls: ['./inventory-departments.component.scss'],
})
export class InventoryDepartmentsComponent implements OnInit {
    _globals = GlobalService;
    @ViewChild('op') op: OverlayPanel;
    @ViewChild('dt') dt: Table;
    @ViewChild('tb') tb: TableBody;

    first = 0;
    page = 0;
    rows = 10;
    totalRecords: number = 0;

    searchText = '';
    lastSearchText = '';
    dataList: any = [];
    selectAll = false;

    selectedRow: any = '';

    //order
    orderParam = '';
    orderBy = '';

    colheader = [['Department Name', 'Status']];

    colflds = ['departmentName', 'isActive'];

    csvcols = [];
    exportColumns: any = '';

    actions: MenuItem[] = [
        {
            label: 'Edit',
            icon: 'pi pi-book',
            command: () => {
                this.update();
            },
        },
        {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
                this.delete();
            },
        },
    ];

    @ViewChild('p', { static: false }) paginator: Paginator;

    constructor(
        private _router: Router,
        private _bs: BaseService,
        public _departmentService: DepartmentService,
        public _catService: CategoryService,
        private _spinner: NgxSpinnerService,
        private _connMessageService: ConnMessageService,
        private _confirmationService: ConfirmationService,
        public _abd: AppBaseDataService,
        public _filterService: FilterServiceService
    ) {}

    ngOnInit(): void { 
        this._globals.componentName = 'Departments';
    }

    ngOnDestroy() {
        this._globals.componentName = '';
    }

    ngAfterViewInit() {
        let ti = null;
        ti = setInterval(() => {
            //--
           
            this._globals.showProductDelButton = false;

            let ppages = this._filterService.getPages(
                this._globals.componentName
            );
            if (ppages) {
                let lastpage = parseInt(ppages.page);
                if (lastpage < 0) lastpage = 0;
                if (lastpage > 0) {
                    this.page = lastpage;
                    this.first = lastpage * this.rows;
                }
            }

            let filter = this._filterService.getFilters(
                this._globals.componentName
            );
            if (filter) {
                if (filter.searchText) {
                    this._filterService.searchText = filter.searchText;
                    this.searchText = filter.search;
                }
            }

            let oorderby = this._filterService.getOrderby(
                this._globals.componentName
            );
            if (oorderby) {
                this.orderParam = oorderby.orderParam;
                this.orderBy = oorderby.orderBy;
            }

            this._departmentService.showNewEdit = false;
            this._departmentService.showNewNewEdit = false;

            this.getDataList();
            try {
                // this.refreshMotherData()
                this.csvcols = this._abd.makeCsvCols(
                    this.colheader,
                    this.colflds
                );
                this.exportColumns = this.csvcols.map((col) => ({
                    title: col.header,
                    dataKey: col.field,
                }));
            } catch {
                // this._abd.loadInit()
            }
            //--
            clearInterval(ti);
        }, 200);
    }

    getDataList() {
        try {
            this._spinner.show();
            this.searchText = this._filterService.searchText;
            let params = new HttpParams();

            this.page = this.page < 1 ? 0 : this.page;
            this.rows = this.rows < 1 ? 10 : this.rows;

            params = params.append('pageNo', this.page);
            params = params.append('pageSize', this.rows);
            params = params.append('filterValue', this.searchText);

            const outfilter = {
                searchText: this.searchText ? this.searchText : '',
            };

            this._filterService.updateFilters(
                this._globals.componentName,
                outfilter
            );
            this._filterService.updatePages(this._globals.componentName, {
                page: this.page,
                rows: this.rows,
            });

            let qryParas = null;
            if (this.orderParam && this.orderParam.length > 0) {
                qryParas = `?orderParam=${this.orderParam}&orderBy=${this.orderBy}`;
                this._filterService.updateOrderby(this._globals.componentName, {
                    orderParam: this.orderParam,
                    orderBy: this.orderBy,
                });
            }

            let url =
                environment.InventoryBaseURL + environment.GetDepartmentList;
            if (qryParas) url += qryParas;

            return this._bs.httpGetParams(url, params).subscribe((res) => {
                this._spinner.hide();
                if (res.success) {
                    this.totalRecords = res.totalRecords;
                    this.dataList = res.data;
                }
                for (let i = 0; i < this.dataList.length; i++)
                    this.dataList[i].selected = false;
                return res.data;
            });
        } catch {
            this._spinner.hide();
        }
    }

    onPageChange(e) {
        e.totalRecords = this.totalRecords;
        this.rows = e.rows;
        this.page = e.page;

        this.getDataList();
    }

    addNewFn(e) {
        if (e !== 'department') return;
        this._departmentService.showNewNewEdit = true;
    }

    refreshFn(e) {
        this.getDataList();
    }
    customSort(e) {
        const last = this.orderParam;

        switch (e.sortField) {
            case 'departmentName':
                this.orderParam = 'departmentName';
                break;
            default:
                this.orderParam = '';
        }

        if (this.orderParam !== '') {
            this.orderBy = e.sortOrder == 1 ? 'asc' : 'desc';
            if (last !== this.orderParam) this.orderBy = 'asc';
            this.getDataList();
        }
    }
    refreshMotherData() {
        // this.searchText = ''
        this.page = 0;
        this._abd.getAllDepartments();
    }

    update() {}

    delete() {}

    clearSearchText() {
        this.searchText = '';
        this.lastSearchText = '';
        this._filterService.searchText = '';
        this.filterButtonPressed();
    }

    searchTextSearch() {
        if (this.searchText === this.lastSearchText) return;

        this.lastSearchText = this.searchText;
        this.filterButtonPressed();
    }

    filterButtonPressed() {
        this.page = 0;
        this.implementLocalFilter();
    }

    implementLocalFilter() {
        this.page = 0;
        this.getDataList();
    }

    uncheckAll() {
        for (let i = 0; i < this.dataList.length; i++) {
            this.dataList[i].selected = false;
        }
    }

    selectAllChanged(event) {
        for (let i = 0; i < this.dataList.length; i++)
            this.dataList[i].selected = event.checked;

        this._globals.showProductDelButton = event.checked;
    }

    selectionChanged(event) {
        let ret = false;
        if (!event.checked) {
            this.selectAll = this.selectAll ? !this.selectAll : this.selectAll;
        }

        for (let i = 0; i < this.dataList.length; i++)
            if (this.dataList[i].selected) {
                ret = true;
                break;
            }

        if (event.checked) {
            const sel = this.dataList.filter((f) => f.selected);
            if (sel.length == this.dataList.length) this.selectAll = true;
            else this.selectAll = false;
        }

        this._globals.showProductDelButton = ret;
    }

    commaSeperatedDeparmentIds(): string {
        let selectedItems: string = '';
        let z = this.dataList.filter((x) => x.selected);
        z.forEach((x) => {
            selectedItems += x.id + ',';
        });
        selectedItems = selectedItems.slice(0, -1);
        return selectedItems;
    }

    deleteMultipleItem() {
        if (this.dataList.length < 1) {
            this._connMessageService.showToastMessage(
                `Nothing to delete!`,
                'error'
            );
            return;
        }

        let selectedItems = this.commaSeperatedDeparmentIds();
        this.op.hide();
        this._confirmationService.confirm({
            message:
                'Deleting process causes permanent loss of information. Are you sure to proceed',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this._abd.showSpinner();
                try {
                    this._departmentService
                        .deleteDepartment(selectedItems)
                        .subscribe((res) => {
                            this._abd.hideSpinner();
                            if (res.success) {
                                this._globals.showProductDelButton = false;
                                this.refreshMotherData();
                                this.getDataList();
                                this._connMessageService.showToastMessage(
                                    `Selected Departments deleted!`,
                                    'success'
                                );
                            }
                        });
                } catch {
                    this._abd.hideSpinner();
                }
            },
            reject: () => {},
        });
    }

    actionButtonClick(item: any) {
        this._departmentService.activeItem = JSON.parse(JSON.stringify(item));
    }

    optionEditClicked() {
        this._departmentService.isViewOnly = false;
        this._departmentService.showNewEdit = true;
        this.op.hide();
    }

    optionDeleteClicked() {
        this.op.hide();
        this._confirmationService.confirm({
            message:
                'Deleting process causes permanent loss of information. Are you sure to proceed',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this._abd.showSpinner();
                try {
                    this._departmentService
                        .deleteDepartment(this._departmentService.activeItem.id)
                        .subscribe((res) => {
                            this._abd.hideSpinner();
                            if (res.success) {
                                this._globals.showProductDelButton = false;
                                this.getDataList();
                                this.refreshMotherData();
                                this._connMessageService.showToastMessage(
                                    `Department "${this._departmentService.activeItem.departmentName}" deleted!`,
                                    'success'
                                );
                            }
                        });
                } catch {
                    this._abd.hideSpinner();
                }
            },
            reject: () => {},
        });
    }

    callbackFuncFromFilter(event) {
        this.implementLocalFilter();
    }

    exportExcel() {
        let data = [];
        this._abd.departmentsBS$.subscribe((res) => {
            data = res;
        });
        this._abd.exportExcel(
            data,
            this.colheader[0],
            this.colflds,
            'Departments List'
        );
    }

    exportPdf() {
        let data = [];
        this._abd.departmentsBS$.subscribe((res) => {
            data = res;
        });

        this._abd.exportPdf(
            data,
            this.colheader,
            this.colflds,
            'Departments List',
            false,
            false,
            false
        );
    }

    onRowSelect(e) {
        try {
            const el = e.originalEvent.srcElement.className;
            if (el && el.includes('p-checkbox')) return;
        } catch {}

        this._departmentService.activeItem = JSON.parse(JSON.stringify(e.data));
        this._departmentService.isViewOnly = true;
        this._departmentService.showNewEdit = true;
    }

    onRowUnselect(e) {}
}
